import { MANAGER_ROLE, ADMIN_ROLE } from '@/lib/user/roles';
import {
    ACCOUNT,
    PLATFORM_OPTIONS,
    DATA_ACCESS,
    THEMES,
    USERS_ROLES,
    SOCIAL_PROFILES,
    SECURITY,
    SUBSCRIPTION_INVOICES,
    REFERRAL_PROGRAM,
    GROUPS,
    INTEGRATIONS
} from '@/routes/privateRoutes';

export type SettingsMenuType = SettingsMenuEntryType[];

export type SettingsMenuEntryType = {
    icon?: string;
    link?: string;
    name: string;
    shouldBeDisplayed?: string;
    target_blank?: boolean;
    urlActiveMenu?: string[];
    acl?: {
        roles: string[];
    };
};

const settings: SettingsMenuType = [
    {
        icon: 'settings',
        link: ACCOUNT,
        name: 'commons:menu.settings',
        urlActiveMenu: [
            ACCOUNT,
            DATA_ACCESS,
            PLATFORM_OPTIONS,
            THEMES,
            SECURITY,
            SUBSCRIPTION_INVOICES,
            INTEGRATIONS
        ]
    },
    {
        icon: 'single-profile',
        link: SOCIAL_PROFILES,
        name: 'commons:menu.social_profiles'
    },
    {
        icon: 'group',
        link: GROUPS,
        name: 'commons:menu.groups'
    },
    {
        icon: 'users-roles',
        link: USERS_ROLES,
        name: 'commons:menu.users_roles',
        acl: {
            roles: [ADMIN_ROLE, MANAGER_ROLE]
        }
    },
    {
        name: 'separator_content'
    },
    {
        icon: 'help',
        target_blank: true,
        link: 'https://support.iconosquare.com',
        name: 'commons:menu.help_center'
    },
    {
        icon: 'product-updates',
        target_blank: true,
        link: 'https://www.iconosquare.com{lang}product-updates',
        name: 'commons:menu.product_updates'
    },
    {
        icon: 'hand-share',
        link: REFERRAL_PROGRAM,
        name: 'commons:menu.referral_program'
    }
];

export default settings;
